import { STR, gasMOD, gasName } from "../i18n.js";
import { useStore } from "../store.js";
import { Plus, X } from "./Icons.js";
import { NumberField, Panel } from "./ui-primitives.js";

export function GasManager() {
  const { gases, lang, setGas, addGas, removeGas } = useStore();
  const t = STR[lang];

  return (
    <Panel
      title={t.gases}
      action={
        <button className="btn btn-ghost" onClick={addGas}>
          <Plus size={12} />
          {t.add}
        </button>
      }
      flush
    >
      <div className="gas-list" style={{ padding: "12px 14px" }}>
        {gases.map((g, i) => {
          const o2 = Math.round(g.fO2 * 100);
          const info = gasName(g);
          const m14 = gasMOD(g.fO2, 1.4).toFixed(0);
          return (
            <div key={i} className="gas-row">
              <div className={`gas-tag ${info.cls}`}>{info.tag}</div>
              <NumberField
                value={o2}
                min={5}
                max={100}
                suffix="%O₂"
                onChange={(v) => setGas(i, { fO2: v / 100 })}
              />
              <div className="gas-detail">
                <span className="pri">{info.name}</span>
                <span className="sec">MOD {m14}m · ppO₂ 1.4</span>
              </div>
              {gases.length > 1 ? (
                <button className="btn-icon danger" onClick={() => removeGas(i)}>
                  <X size={12} />
                </button>
              ) : (
                <span />
              )}
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
